export default function migrateModifier(modifier) {
  return modifier
}
